export default __webpack_public_path__ + "rn-android@2x.png";